<template>
  <Transition name="slide-fade" appear>
    <div v-if="visible" class="modal-end">
      <div class="modal-content">
        <div class="modal-step-1">
          <div class="modal-header">
            <span class="modal-header-txt">{{$t('add_visual')}}</span>
            <span class="modal-header-description">{{$t('add_visuals_your_question')}}</span>
          </div>

          <div class="visual-list">
            <draggable
                v-model="this.visuals"
                item-key="order"
            >
              <template #item="{element}">
                <div class="visual-wrapper">
                  <div class="visual-wrapper-left">
                    <img src="@/assets/images/drag.svg" />
                    <div class="visual-info-row">
                      <span class="visual-title">{{$t('image')}}</span>
                      <span class="visual-text">{{$t('can_add_text_your_images')}}</span>
                      <input class="form-input" :placeholder="this.$t('optional')" v-model="element.name" />
                    </div>
                  </div>
                  <div class="visual-wrapper-right">
                    <FileDrop
                        :ratio="'1 × 🖼️ → 1920 × 1080\n2+ × 🖼️ → 1920 × 1920'"
                        :on-file-selected="handleFile(element)"
                        :selected-file="element.file?.attachUrl"
                        :attach="element.attach"
                        :file-info="element.file?.info"
                        :fresh-start="afterImageDelete(element)"
                        :on-delete="handleImageDelete(element)"
                        :not-binary=notBinary
                    />
                  </div>
                </div>
              </template>
            </draggable>

            <button class="add-image-button" @click="addImageSlot">
              <img src="@/assets/images/plusBlue.svg" />
              {{$t('add_another_image')}}
            </button>

          </div>


          <div @click="this.onHide" class="close-btn">
            <img class="cross" src="../../assets/images/cross.svg" />
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import { ref, watch } from 'vue';
import TextInput from "@/components/TextInput.vue";
import SelectBox from "@/components/SelectBox.vue";
import FileDrop from "@/components/FileDrop.vue";
import draggable from "vuedraggable";

export default {
  props: {
    notBinary: {
      type: Boolean,
      default: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    onHide: {
      type: Function,
      default: () => {}
    },
    modelValue: {
      type: Array,
      default: () => [
        {
          order: 1,
          name: "",
          attach: null
        },
      ]
    }
  },
  components: {
    draggable,
    FileDrop,
    TextInput,
    SelectBox
  },
  setup(props, { emit }) {
    const visuals = ref(props.modelValue);

    watch(visuals, (newVal) => {
      emit('update:modelValue', newVal);
    });

    const handleFile = (element) => (file) => {
      element.attach = file;
      element.attachDelete = 0;
      element.attachUrl = null;

      emit('update:modelValue', visuals.value);
    };

    const addImageSlot = () => {
      if (visuals.value === null) {
        visuals.value = [];
      }

      visuals.value.push({
        order: visuals.value.length + 1,
        name: "",
        attach: null
      });

      emit('update:modelValue', visuals.value);
    };

    const handleImageDelete = (element) => () => {
      element.attachDelete = 1;
      element.attach = null;
      element.file.attachUrl = null;

      emit('update:modelValue', visuals.value);
    };
    const afterImageDelete = (element) => () => {
      element.attachDelete = 0;

    };

    return {
      visuals,
      handleFile,
      handleImageDelete,
      afterImageDelete,
      addImageSlot
    };
  },
};
</script>

<style scoped>
.modal-content {
  position: relative;
  background-color: white;
  width: 50%;
  height: 100%;
  border-radius: 12px;
  padding: 24px;
  overflow-y: auto;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
}

.modal-content::-webkit-scrollbar {
  width: 15px;
}

.modal-content::-webkit-scrollbar-track {
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #FFF;
}

.modal-content::-webkit-scrollbar-thumb {
  background-color: rgba(4, 12, 45, 0.2);
  border-radius: 10px;
  border: 5px transparent solid;
  background-clip: padding-box;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background-color: rgba(4, 12, 45, 0.4);
}

.close-btn {
  position: absolute;
  top: 24px;
  right: 24px;
  background: none;
  border: none;
  cursor: pointer;
  background-color: #F2F4F7;
  border-radius: 3000px;
}
.cross{
  padding: 8px;
}
.modal-header{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 0 10px 0;
  border: none;
}

.modal-header-txt{
  font-family: euclid_semi_bold, sans-serif;
  color: #040C2D;
  font-size: 18px;
  font-style: normal;
  line-height: 24px;
}
.modal-header-description {
  font-family: euclid_medium, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}
.btn-style{
  display: flex;
  border-radius: 24px;
  background: #040C2D;
  justify-content: center;
  align-items: center;
  width: 20%;
  height: 48px;
  cursor: pointer;
}

.next-txt{
  font-family: euclid_medium, sans-serif;
  color: #FFF;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}
.btn-div{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
}
h5 {
  font-family: euclid_medium, sans-serif;
  color: #010511;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 20px;
}

.visual-wrapper {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 20px;
}

.visual-wrapper-left {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-start;
  width: 100%;
}

.visual-info-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
}

.visual-wrapper-right {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  width: 100%;
}

.visual-title {
  font-family: euclid_medium, sans-serif;
  color: #040C2D;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
}

.visual-text {
  font-family: euclid_regular, sans-serif;
  color: #667085;
  font-size: 14px;
  font-style: normal;
  line-height: 20px;
}

.visual-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.add-image-button {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 5px;
  padding: 10px 20px;
  background-color: transparent;
  border-radius: 12px;
  color: #4A68F8;
  font-family: euclid_medium, sans-serif;
  font-size: 12px;
  cursor: pointer;
  border: none;
  outline: none;
}
</style>
